import React from 'react'
import { List } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { UserSaleOffer } from 'src/core/models'
import { currencyListSelector } from 'src/features'
import { CustomText, SaleOfferStatusColumn } from 'src/components'
import { getFormatedPrice, getProjectUnit, getTransformedDate } from 'src/core/helpers'

const SaleOfferDetails: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  const { t } = useTranslation()
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList?.find(c => c.id === offer.currency)?.code

  const offerLabels = [
    { label1: t('Projects.Vintage'), label2: offer.vintage_year, show: offer.vintage_year },
    { label1: t('Deposits.Amount'), label2: `${offer.amount} ${getProjectUnit(offer.project_kind)}`, show: true },
    { label1: t('SalesOffer.Price'), label2: getFormatedPrice(offer.price_per_unit, currencyCode), show: true },
    { label1: t('settings.Currency'), label2: currencyCode, show: true },
    { label1: t('Discount.Title'), label2: `${offer.discount}%`, show: offer.show_discount && offer.discount },
    { label1: t('SalesOffer.Total'), label2: getFormatedPrice(offer.total, currencyCode), show: true },
    { label1: t('SalesOffer.ExpirationDate'), label2: getTransformedDate(offer.expiration_date), show: offer.expiration_date },
    { label1: t('Deposits.Status'), label2: <SaleOfferStatusColumn offer={offer} />, show: true, isComponent: true },
  ]

  return (
    <List
      dataSource={offerLabels}
      renderItem={item => {
        if (!item.show) return
        return (
          <List.Item>
            <React.Fragment>
              <CustomText label={item.label1} type='secondary' />
              {item.isComponent ? item.label2 : <CustomText label={item.label2} type={null} />}
            </React.Fragment>
          </List.Item>
        )
      }}
    />
  )
}

export default SaleOfferDetails
